import { useContext } from "react";

import { useParams } from "react-router";

import { NotFoundPage as NotFound } from "@/components/pages_public/404";
import { Article } from "@/components/pieces/article";
import { ArticleSkeleton } from "@/components/pieces/learn/ArticleSkeleton";
import { ResponseContext } from "@/components/ResponseContext";
import { useArticleQuery } from "@/graphql";
import { ArticleWithReadStatus } from "@/types/articles";

export function LearnArticle() {
  const { res } = useContext(ResponseContext);
  const { slug } = useParams();

  const { data } = useArticleQuery({
    variables: {
      slug: slug || "",
    },
    skip: !slug,
  });

  if (!data) {
    return <ArticleSkeleton />;
  }

  const { article, articleReadStatus } = data;
  let updatedArticle = { ...article } as ArticleWithReadStatus;
  if (article && articleReadStatus) {
    updatedArticle = {
      ...article,
      currentUserReadStatus: articleReadStatus.readStatus,
    } as ArticleWithReadStatus;
  }

  if (!updatedArticle) {
    if (res) {
      res.status(404);
    }
    return <NotFound />;
  }

  return <Article article={updatedArticle} />;
}
